import {
  InputGroup, Button, Row, Form as BsForm,
} from 'react-bootstrap'
import debounce from 'lodash/debounce'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSearch, faTimes
} from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import styles from './index.module.scss'
import Form from '../Form'
import withLocale from '~/hocs/locale'

const SearchInput = ({
  name,
  value,
  size,
  className,
  onSearch,
  onChange,
  onAdvancedSearchClick,
  advancedSearchClassName,
  advancedSearch,
  placeholder,
}) => {
  const handleChange = debounce((val) => {
    onChange?.({ [name]: val })
  }, 350)

  const handleClear = () => {
    onChange?.({ [name]: '' })
    onSearch?.({ [name]: '' })
  }

  return (
    <Form onSubmit={onSearch} initialValues={{ [name]: value }} noValidate>
      <BsForm.Group as={Row} controlId="emailSearch" className="m-0">
        <InputGroup size={size} className={`justify-content-end ml-auto ${styles.inputGroup} ${className}`}>
          <InputGroup.Prepend>
            <InputGroup.Text className={styles.iconContainer}>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
          </InputGroup.Prepend>
          <Form.SimpleField
            type="text"
            placeholder={placeholder}
            name={name}
            className={styles.input}
            onChange={handleChange}
          />
          {value && (
          <InputGroup.Append>
            <Button
              as={InputGroup.Text}
              className={styles.clearButtonContainer}
              variant="transparent"
              onClick={handleClear}
            ><FontAwesomeIcon icon={faTimes} />
            </Button>
          </InputGroup.Append>
          )}
        </InputGroup>
        {onAdvancedSearchClick && (
        <Button
          variant="link"
          className={`p-0 my-2 ${styles.advancedSearch} ${advancedSearchClassName}`}
          onClick={onAdvancedSearchClick}
        >
          {advancedSearch}
        </Button>
        )}
      </BsForm.Group>
    </Form>
  )
}

SearchInput.propTypes = {
  onSearch: PropTypes.func,
  onAdvancedSearchClick: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  name: PropTypes.string,
  advancedSearchClassName: PropTypes.string,
  advancedSearch: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
}

SearchInput.defaultProps = {
  value: '',
  name: 'search',
  onChange: null,
  onSearch: null,
  onAdvancedSearchClick: null,
  advancedSearchClassName: '',
  advancedSearch: 'Advanced search',
  placeholder: 'Search',
  size: 'sm',
  className: '',
}

export default withLocale('common', 'searchInput')(SearchInput)
